<template name="default">
    <section
        v-if="options !== null"
        class="module"
    >
        <div class="lb-portal">
            <div :class="[{ 'box-list': true, 'no-abstract': !options.ShowAbstract }, options.BoxBackgroundColor]">
                <div class="container grid-y">
                    <h1
                        class="cell box-list-header"
                        v-html="options.Title"
                    />
                    <div
                        class="cell small-12 grid-x"
                    >
                        <box-component
                            v-for="(box, i) in options.Boxes"
                            :key="i"
                            :options="box"
                            :show-abstract="options.ShowAbstract"
                        />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import BoxComponent from './BoxComponent.vue';

export default {
    name: 'BoxList',
    components: {
        BoxComponent
    },
    mixins: [
    ],
    props: {
        options: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    computed: {}
};
</script>
<style lang="scss" scoped>
.box-list {
    margin-bottom: 0;
    padding-bottom: 1.3333333333rem;
}
</style>
